import { ApplicationUser } from '@/types/application-user';

export const isUserPlatformAdmin = (
  user: Pick<ApplicationUser, 'role'>,
): boolean => user.role.id === 1;
